import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=dc113336&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=dc113336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc113336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc113336')) {
      api.createRecord('dc113336', component.options)
    } else {
      api.reload('dc113336', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=dc113336&scoped=true&", function () {
      api.rerender('dc113336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KrC0rzdYyKR7/JS/comp/SearchFilterTokens.vue"
export default component.exports